import { useQuery } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'
import { RecruiterData } from 'builder/modules/resumeDistribution'

type UseGetRecruitersProps = {
  enabled?: boolean
}

export const useGetRecruiters = ({ enabled = true }: UseGetRecruitersProps) => {
  return useQuery(
    ['resumeDistributionRecruiters'],
    async (): Promise<RecruiterData> => {
      const url = '/resume-distribution/candidates/recruiters'
      const { data } = await baseClient.get<RecruiterData>(url)
      return data
    },
    { enabled, useErrorBoundary: false },
  )
}
